const clamp=(n,min,max)=>Math.max(min,Math.min(max,n));
export const canvasZoom=value=>clamp(value,.7,3);
export function canvasPan(pan,zoom,rect,moveMode=false){
 const extra=Math.max(moveMode ? .5 : 0,zoom-1)/2;
 if(!extra)return {x:0,y:0};
 return {x:clamp(pan.x,-rect.width*extra,rect.width*extra),y:clamp(pan.y,-rect.height*extra,rect.height*extra)};
}
export function pinchViewport(start,points){
 const zoom=canvasZoom(start.zoom*Math.hypot(points[1].x-points[0].x,points[1].y-points[0].y)/(start.distance||1));
 const ratio=zoom/start.zoom,center={x:(points[0].x+points[1].x)/2,y:(points[0].y+points[1].y)/2};
 const origin={x:start.rect.left+start.rect.width/2,y:start.rect.top+start.rect.height/2};
 const pan=canvasPan({x:center.x-origin.x-(start.center.x-origin.x-start.pan.x)*ratio,y:center.y-origin.y-(start.center.y-origin.y-start.pan.y)*ratio},zoom,start.rect);
 return {zoom,pan};
}
